<template>
  <div v-if="loading" class="preview-multi-select">
    <b>CFOP:</b> <span>Selecione</span>
  </div>
  <MultiSelect
    v-else
    label="CFOP"
    :campos="cfops"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="atualizar"
  />
</template>
<script>
import Multiselect from '../../mixins/Multiselect.js';

export default {
  mixins: [Multiselect],
  data() {
    return {
      cfops: [],
      loading: true
    }
  },
  mounted() {
    this.$api.get('/cfops').then(response => {
      const cfops = response.data;
      this.cfops = cfops.map(cfop => ({
        id: cfop.id,
        name: cfop.codigo
      }));

      this.loading = false;
    })
  }
}
</script>
